import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import "../../styles/Asummery.css";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";

function SAsummery() {
  const [pivotData, setPivotData] = useState([]);
  const [emails, setEmails] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [emailStatus, setEmailStatus] = useState("");

  // ✅ Initialize EmailJS (run once on component mount)
  useEffect(() => {
    emailjs.init("poMjLpgbDWMlrTmI8");
    console.log("📧 EmailJS initialized");
  }, []);

  // ✅ Check if user has at least one visit in the last 30 days
  function hasRecentActivity(userEmail, reviews) {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    
    return reviews.some(r => {
      if (!r.createdAt?.toDate) return false;
      const visitDate = r.createdAt.toDate();
      const emailMatch = (r.userEmail || "").trim().toLowerCase() === userEmail.trim().toLowerCase();
      return emailMatch && visitDate >= thirtyDaysAgo;
    });
  }

  // ✅ NEW: Check if user has any views in a specific hotel
  function hasViewsInHotel(userEmail, hotelReviews) {
    return hotelReviews.some(r => {
      const reviewEmail = (r.userEmail || "").trim().toLowerCase();
      const targetEmail = userEmail.trim().toLowerCase();
      return reviewEmail === targetEmail;
    });
  }

  // ✅ Send email to admins if non-compliant (HOTEL-WISE)
  async function sendEmailAlert(nonCompliantByHotel, weekRangeText, activeEmails) {
    const ADMIN_EMAILS = [
      "adishav@yahoo.com",
      "sarachandrahotels@gmail.com",
      // "rm.lake@centauriahotels.com",
      // "centaurialakehotel@gmail.com",
      
    ];

    console.log("📧 sendEmailAlert called");
    console.log("Hotels with issues:", Object.keys(nonCompliantByHotel).length);

    // Check if all hotels are compliant
    const hasIssues = Object.values(nonCompliantByHotel).some(
      hotel => hotel.nonCompliant.length > 0
    );

    if (!hasIssues) {
      console.log("✅ All users compliant in all hotels!");
      setEmailStatus("✅ All users are compliant in all hotels!");
      return;
    }

    // 🔹 Build HOTEL-WISE HTML content (only for active users)
    const messageHtml = Object.entries(nonCompliantByHotel)
      .filter(([_, hotelData]) => hotelData.nonCompliant.length > 0)
      .map(([hotelName, hotelData]) => {
        const nonCompliant = hotelData.nonCompliant;
        
        // 🔹 Filter to only include active users (with recent visits)
        const activeNonCompliant = nonCompliant.filter(item => 
          activeEmails.includes(item.email)
        );

        if (activeNonCompliant.length === 0) {
          return ''; // Skip this hotel if no active users with issues
        }
        
        // Group by user email
        const grouped = activeNonCompliant.reduce((acc, item) => {
          if (!acc[item.email]) {
            acc[item.email] = {
              points: [],
              totalIssues: 0
            };
          }
          acc[item.email].points.push(`${item.point} (${item.count})`);
          acc[item.email].totalIssues++;
          return acc;
        }, {});

        const userCount = Object.keys(grouped).length;
        const totalIssues = activeNonCompliant.length;

        // Limit to first 15 users per hotel
        const userEntries = Object.entries(grouped).slice(0, 15);
        const hasMore = Object.keys(grouped).length > 15;

        const usersHtml = userEntries
          .map(([email, data]) => {
            // Limit to first 8 points per user
            const points = data.points.slice(0, 8);
            const morePoints = data.points.length > 8;
            
            const pointsList = points
              .map(p => `• ${p}`)
              .join("<br>");
            
            return `
              <div style="margin-bottom: 10px; padding: 6px; background: #fff; border-left: 2px solid #d9534f;">
                <strong>${email}</strong> (${data.totalIssues} points)<br>
                <div style="font-size: 12px; margin-top: 3px;">${pointsList}</div>
                ${morePoints ? `<div style="font-size: 11px; color: #666;">...and ${data.points.length - 8} more</div>` : ''}
              </div>
            `;
          })
          .join("");

        return `
          <div style="margin-bottom: 20px; border: 1px solid #ddd; border-radius: 6px; padding: 12px; background: #fafafa;">
            <h4 style="margin: 0 0 10px 0; color: #d9534f;">🏨 ${hotelName}</h4>
            <div style="background: #f8f9fa; padding: 8px; border-radius: 4px; margin-bottom: 10px; font-size: 13px;">
              <strong>Summary:</strong> ${userCount} user(s) with ${totalIssues} non-compliant point(s)
              ${hasMore ? '<br><em style="color: #666;">(Showing first 15 users)</em>' : ''}
            </div>
            ${usersHtml}
          </div>
        `;
      })
      .filter(html => html !== '') // Remove empty hotel sections
      .join("");

    if (!messageHtml) {
      console.log("✅ No active users with compliance issues!");
      setEmailStatus("✅ No active users with issues");
      return;
    }

    // Count total issues across all hotels (only active users)
    const totalHotelsWithIssues = Object.values(nonCompliantByHotel)
      .filter(h => h.nonCompliant.some(item => activeEmails.includes(item.email)))
      .length;
    const totalIssuesAllHotels = Object.values(nonCompliantByHotel)
      .reduce((sum, h) => sum + h.nonCompliant.filter(item => activeEmails.includes(item.email)).length, 0);

    const subject = `⚠️ Weekly Compliance Report (${weekRangeText}) – All Hotels`;

    console.log("📤 Sending emails to:", ADMIN_EMAILS);
    console.log("Subject:", subject);
    console.log("Total hotels with issues:", totalHotelsWithIssues);
    console.log("Total issues across all hotels:", totalIssuesAllHotels);
    setEmailStatus("📤 Sending emails...");

    try {
      const emailPromises = ADMIN_EMAILS.map(async (to) => {
        console.log(`Sending email to: ${to}...`);
        
        const result = await emailjs.send(
          "service_ykkzu2w",
          "template_4fd9dfk",
          {
            to_email: to,
            hotel_name: "All Hotels",
            week_range: weekRangeText,
            message_html: `
              <div style="background: #e3f2fd; padding: 12px; border-radius: 4px; margin-bottom: 12px; border-left: 4px solid #2196f3;">
                <strong>Overall Summary:</strong> ${totalHotelsWithIssues} hotel(s) with compliance issues<br>
                <strong>Total Issues:</strong> ${totalIssuesAllHotels} non-compliant point(s)
              </div>
              ${messageHtml}
            `,
            subject_line: subject,
          },
          "poMjLpgbDWMlrTmI8"
        );
        
        console.log(`✅ Email sent to ${to}:`, result.status, result.text);
        return result;
      });

      await Promise.all(emailPromises);
      console.log("📨 All emails sent successfully!");
      setEmailStatus(`✅ Emails sent! (${totalHotelsWithIssues} hotels, ${totalIssuesAllHotels} issues)`);
      
      alert(`Weekly compliance report sent successfully!\n${totalHotelsWithIssues} hotels with ${totalIssuesAllHotels} non-compliant points.`);
      
    } catch (error) {
      console.error("❌ EmailJS Error:", error);
      console.error("Error details:", error.text || error.message);
      
      if (error.text && error.text.includes("Variables size limit")) {
        console.log("⚠️ Email too large, sending summary only...");
        await sendSummaryEmail(ADMIN_EMAILS, nonCompliantByHotel, weekRangeText, activeEmails);
      } else {
        setEmailStatus("❌ Failed to send emails. Check console.");
        alert(`Failed to send emails: ${error.text || error.message}`);
      }
    }
  }

  // 🔹 Fallback: Send summary-only email if data is too large
  async function sendSummaryEmail(adminEmails, nonCompliantByHotel, weekRangeText, activeEmails) {
    try {
      const hotelsSummary = Object.entries(nonCompliantByHotel)
        .filter(([_, hotelData]) => hotelData.nonCompliant.some(item => activeEmails.includes(item.email)))
        .map(([hotelName, hotelData]) => {
          const activeNonCompliant = hotelData.nonCompliant.filter(item => activeEmails.includes(item.email));
          const userCount = new Set(activeNonCompliant.map(n => n.email)).size;
          const issueCount = activeNonCompliant.length;
          return `<strong>${hotelName}:</strong> ${userCount} users, ${issueCount} issues`;
        })
        .join("<br>");

      const totalHotels = Object.values(nonCompliantByHotel)
        .filter(h => h.nonCompliant.some(item => activeEmails.includes(item.email)))
        .length;
      const totalIssues = Object.values(nonCompliantByHotel)
        .reduce((sum, h) => sum + h.nonCompliant.filter(item => activeEmails.includes(item.email)).length, 0);

      const summaryHtml = `
        <div style="background: #fff3cd; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
          ⚠️ <strong>Note:</strong> Full report too large. Showing summary only.
        </div>
        <div style="background: #f8f9fa; padding: 12px; border-radius: 4px;">
          <strong>Total:</strong> ${totalHotels} hotel(s) | ${totalIssues} non-compliant point(s)<br><br>
          <strong>Hotels with issues:</strong><br>
          ${hotelsSummary}
        </div>
        <p style="margin-top: 16px; color: #666; font-size: 14px;">
          Please check the admin dashboard for full details.
        </p>
      `;

      await Promise.all(
        adminEmails.map(to =>
          emailjs.send(
            "service_ykkzu2w",
            "template_4fd9dfk",
            {
              to_email: to,
              hotel_name: "All Hotels",
              week_range: weekRangeText,
              message_html: summaryHtml,
              subject_line: `⚠️ Weekly Compliance Summary (${weekRangeText}) – All Hotels`,
            },
            "poMjLpgbDWMlrTmI8"
          )
        )
      );

      console.log("📨 Summary email sent successfully!");
      setEmailStatus(`✅ Summary sent! (${totalHotels} hotels, ${totalIssues} issues)`);
      alert(`Summary email sent!\n${totalHotels} hotels with ${totalIssues} issues.`);
    } catch (error) {
      console.error("❌ Failed to send summary email:", error);
      setEmailStatus("❌ Failed to send summary email");
      alert("Failed to send even summary email. Please check console.");
    }
  }

  // ✅ Weekly compliance check (last 7 days) - HOTEL-WISE
  async function checkWeeklyCompliance(reviewList, allowedEmails, uniqueHotels) {
    const endOfRange = new Date();
    const startOfRange = new Date();
    startOfRange.setDate(endOfRange.getDate() - 6);
    startOfRange.setHours(0, 0, 0, 0);
    endOfRange.setHours(23, 59, 59, 999);

    const weekRangeText = `${startOfRange.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
    })} – ${endOfRange.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    })}`;

    console.log("📅 Checking compliance for last 7 days:", weekRangeText);

    // 🔹 Filter to only active users (at least 1 visit in last 30 days)
    const activeEmails = allowedEmails.filter(email => 
      hasRecentActivity(email, reviewList)
    );

    console.log("👥 Active users (with visits in last 30 days):", activeEmails);
    console.log("🚫 Inactive users filtered out:", allowedEmails.length - activeEmails.length);

    // Build non-compliant data organized by hotel
    const nonCompliantByHotel = {};

    for (const hotel of uniqueHotels) {
      const hotelReviews = reviewList.filter(
        r => (r.hotelName || "Unknown Hotel") === hotel
      );

      // 🔹 NEW: Get users who have views in this specific hotel
      const hotelActiveEmails = activeEmails.filter(email =>
        hasViewsInHotel(email, hotelReviews)
      );

      console.log(`🏨 ${hotel}: ${hotelActiveEmails.length} users with views`);

      // Get unique points for this hotel (excluding SP)
      const uniquePoints = [
        ...new Set(
          hotelReviews
            .map((r) => r.qrData || "Unknown Point")
            .filter((point) => !point.toLowerCase().startsWith("s p"))
        ),
      ];

      const nonCompliant = [];

      // 🔹 Only check users who have views in this hotel
      for (const email of hotelActiveEmails) {
        for (const point of uniquePoints) {
          const userReviews = hotelReviews.filter((r) => {
            if (!r.createdAt?.toDate) return false;
            const visitDate = new Date(r.createdAt.toDate());
            return (
              (r.userEmail || "Unknown") === email &&
              (r.qrData || "Unknown Point") === point &&
              visitDate >= startOfRange &&
              visitDate <= endOfRange
            );
          });

          if (userReviews.length < 7) {
            nonCompliant.push({
              email,
              point,
              count: userReviews.length,
            });
          }
        }
      }

      nonCompliantByHotel[hotel] = {
        nonCompliant,
        hotelName: hotel
      };
    }

    const totalIssues = Object.values(nonCompliantByHotel)
      .reduce((sum, h) => sum + h.nonCompliant.length, 0);

    console.log("Non-compliant count across all hotels:", totalIssues);

    if (totalIssues > 0) {
      await sendEmailAlert(nonCompliantByHotel, weekRangeText, activeEmails);
    } else {
      console.log("✅ All active users compliant in all hotels!");
      setEmailStatus("✅ All users compliant - No email needed");
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        console.log("🔄 Fetching data...");
        
        // 🔹 fetch users with roles
        const usersSnap = await getDocs(collection(db, "users"));
        const usersData = usersSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // 🔹 exclude "security" role emails
        const allowedUsers = usersData.filter((u) => u.role !== "security");
        const allowedEmails = allowedUsers.map((u) => u.email);
        
        console.log("👥 All allowed emails:", allowedEmails);

        // 🔹 fetch ALL reviews first
        let reviews = (await getDocs(collection(db, "reviews")))
          .docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        console.log("📋 Total reviews fetched:", reviews.length);

        // 🔹 filter by selected date range
        if (startDate) {
          const start = new Date(startDate);
          const beforeFilter = reviews.length;
          reviews = reviews.filter(r => {
            if (!r.createdAt?.toDate) return false;
            return r.createdAt.toDate() >= start;
          });
          console.log(`📅 Start date filter: ${beforeFilter} -> ${reviews.length} reviews`);
        }
        
        if (endDate) {
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
          const beforeFilter = reviews.length;
          reviews = reviews.filter(r => {
            if (!r.createdAt?.toDate) return false;
            return r.createdAt.toDate() <= end;
          });
          console.log(`📅 End date filter: ${beforeFilter} -> ${reviews.length} reviews`);
        }

        setReviewList(reviews);

        // 🔹 Filter to only show users with at least 1 visit in last 30 days
        const activeEmails = allowedEmails.filter(email => 
          hasRecentActivity(email, reviews)
        );

        console.log("👥 Active users to display:", activeEmails);
        console.log("🚫 Inactive users hidden:", allowedEmails.length - activeEmails.length);

        // 🔹 collect unique hotels
        const uniqueHotels = [
          ...new Set(reviews.map((r) => r.hotelName || "Unknown Hotel")),
        ];
        
        console.log("🏨 Unique hotels:", uniqueHotels);

        // 🔹 build pivot tables grouped by hotel (only active users WITH VIEWS IN THAT HOTEL)
        const tablesByHotel = uniqueHotels.map((hotel) => {
          const hotelReviews = reviews.filter(
            (r) => (r.hotelName || "Unknown Hotel") === hotel
          );

          console.log(`🏨 ${hotel}: ${hotelReviews.length} reviews`);

          // 🔹 NEW: Filter to only users who have views in this specific hotel
          const hotelActiveEmails = activeEmails.filter(email =>
            hasViewsInHotel(email, hotelReviews)
          );

          console.log(`👥 ${hotel}: ${hotelActiveEmails.length} users with views in this hotel`);

          // 🔹 collect unique points for this hotel but exclude ones starting with "SP"
          const uniquePoints = [
            ...new Set(
              hotelReviews
                .map((r) => r.qrData || "Unknown Point")
                .filter((point) => !point.toLowerCase().startsWith("s p"))
            ),
          ];

          console.log(`📍 ${hotel} unique points:`, uniquePoints);

          const table = uniquePoints.map((point) => {
            const row = { point };
            
            // 🔹 Only include users who have views in this hotel
            hotelActiveEmails.forEach((email) => {
              const userReviews = hotelReviews.filter((r) => {
                const reviewEmail = (r.userEmail || "").trim().toLowerCase();
                const targetEmail = email.trim().toLowerCase();
                const reviewPoint = (r.qrData || "Unknown Point").trim();
                const targetPoint = point.trim();
                
                return reviewEmail === targetEmail && reviewPoint === targetPoint;
              });

              const count = userReviews.length;

              let lastDate = "-";
              if (userReviews.length > 0) {
                const latestReview = userReviews.reduce((latest, current) => {
                  const latestTime = latest.createdAt?.toDate?.()?.getTime?.() || 0;
                  const currentTime = current.createdAt?.toDate?.()?.getTime?.() || 0;
                  return currentTime > latestTime ? current : latest;
                });

                lastDate = latestReview.createdAt?.toDate
                  ? latestReview.createdAt.toDate().toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                    })
                  : "-";
              }

              row[email] = count > 0 ? (
                <>
                  {count}
                  <br />
                  ({lastDate})
                </>
              ) : (
                "-"
              );
            });
            
            return row;
          });

          return { 
            hotel, 
            table,
            emails: hotelActiveEmails // Store hotel-specific emails
          };
        });

        setEmails(activeEmails); // Keep global emails for reference
        setPivotData(tablesByHotel);

        // 🕒 Weekly email check with localStorage to prevent duplicate sends
        const today = new Date();
        const lastEmailDate = localStorage.getItem("lastWeeklyEmailDateSA");
        const todayStr = today.toDateString();

        console.log("📅 Today:", today.toLocaleDateString(), "| Day:", today.getDay());
        console.log("📧 Last email sent:", lastEmailDate || "Never");

        // Send email if it's Sunday (0) AND we haven't sent one today
        if (today.getDay() === 0 && lastEmailDate !== todayStr) {
          console.log("🟢 It's Sunday! Running compliance check...");
          await checkWeeklyCompliance(reviews, allowedEmails, uniqueHotels);
          localStorage.setItem("lastWeeklyEmailDateSA", todayStr);
        } else {
          console.log("⏸️ Not Sunday or email already sent today");
        }
        
        console.log("✅ Data processing complete");
      } catch (error) {
        console.error("Error fetching data:", error);
        setEmailStatus("❌ Error loading data");
      }
    }

    fetchData();
  }, [startDate, endDate]);

  return (
    <div className="summary-container">
      <h2 style={{ color: "black" }}>📊 User Points Summary by Hotel</h2>

      {/* Email Status Display */}
      {emailStatus && (
        <div
          style={{
            padding: "10px",
            marginBottom: "10px",
            backgroundColor: emailStatus.includes("❌") ? "#fee" : "#efe",
            border: `1px solid ${emailStatus.includes("❌") ? "#fcc" : "#cfc"}`,
            borderRadius: "4px",
            fontSize: "14px",
            color: "#000",
            fontWeight: "500",
          }}
        >
          {emailStatus}
        </div>
      )}

      {/* Test Email Button */}
      <button
        onClick={() => {
          console.log("🧪 Manual test triggered");
          if (reviewList.length === 0 || emails.length === 0 || pivotData.length === 0) {
            alert("Please wait for data to load first!");
            return;
          }
          const uniqueHotels = pivotData.map(h => h.hotel);
          
          // Get all allowed users (not just active ones for compliance check)
          const allAllowedEmails = [...emails]; // Active users already filtered
          checkWeeklyCompliance(reviewList, allAllowedEmails, uniqueHotels);
        }}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginRight: "10px",
          marginBottom: "10px",
        }}
      >
        🧪 Send Email
      </button>

      <button
        onClick={() => navigate("/sasecuritysum")}
        className="history-btn"
      >
        Security Points Reviews
      </button>

      <div className="date-filter">
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div>

      {pivotData.length === 0 ? (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          No data to display. Check console for debugging info.
        </div>
      ) : (
        pivotData.map((hotelData, idx) => (
          <div key={idx} className="hotel-section">
            <h3>🏨 {hotelData.hotel}</h3>
            {hotelData.emails.length === 0 ? (
              <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                No users with views in this hotel
              </div>
            ) : (
              <div className="table">
                <table className="summary-table">
                  <thead>
                    <tr>
                      <th>Points</th>
                      {hotelData.emails.map((email, idx2) => (
                        <th key={idx2}>{email.split("@")[0]}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {hotelData.table.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td>{row.point}</td>
                        {hotelData.emails.map((email, idx3) => (
                          <td key={idx3}>{row[email]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default SAsummery;